import { Editor } from 'grapesjs';
import { faMedal } from '@fortawesome/pro-solid-svg-icons/faMedal';
import { AchievementsHistoryTableV2Component } from './transaction-history-table-v2-grapes-component';
import { EditorComponentDefinition } from '../types';
import { Toolbar } from '../../utils';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const achievementsHistoryV2ComponentDefinition: EditorComponentDefinition = {
  id: 'transaction-history-v2',
  icon: faMedal,
  category: 'Profile',
  getLabel: ({ t }) => t('editor.component.achievements-history'),
  component: AchievementsHistoryV2Component,
  copyPasteHelper: markChildrenWithParentType,
};

export function AchievementsHistoryV2Component(editor: Editor) {
  AchievementsHistoryTableV2Component(editor);

  const languages: string[] = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(achievementsHistoryV2ComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains('qlfeditor-achievements-history');
    },
    model: {
      defaults: {
        tagName: 'section',
        category: 'content',
        droppable: false,
        draggable: '[data-gjs-type=column]',
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.achievements-history.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'transaction-history-table-v2',
          },
        ],
        attributes: {
          class: 'qlfeditor-achievements-history',
          tagName: 'section',
          'aria-label': 'aria.transactionHistory.label',
          'aria-description': 'aria.transactionHistory.description',
        },
        traits: [],
      },
      initToolbar: Toolbar,
    },
  });
}
